import type { CSSProperties } from "react";
import { Range as LocalRange, useThumbOverlap } from 'react-range';
import * as React from 'react';

function ThumbLabel({rangeRef, values, index, colorMain, step = 1}) {
	const [labelValue, style] = useThumbOverlap(rangeRef, values, index, step);

	let styleThumb = {
		display: 'block',
		position: 'absolute',
		top: '-28px',
		color: '#fff',
		fontWeight: 'bold',
		fontSize: '12px',
		fontFamily: 'Arial,Helvetica Neue,Helvetica,sans-serif',
		padding: '2px 4px',
		borderRadius: '2px',
		backgroundColor: colorMain,
		whiteSpace: 'nowrap'
	} as CSSProperties;

	return (
		<div data-label={index} style={Object.assign(styleThumb, style)}>
			{labelValue}
		</div>
	);
}

export default function Range(props) {
	const rangeRef = React.useRef();

	let styleTrack = {
		height: '2px',
		width: '100%',
		borderRadius: '3px',
		alignSelf: 'center',
		background: props.background
	};

	let values = props.values;
	let colorMain = props.colorMain;
	let step = props.step ? props.step : 1;

	return (
		<LocalRange
			ref={rangeRef}
			allowOverlap
			renderTrack={({ props, children }) => (
				<div
					onMouseDown={props.onMouseDown}
					onTouchStart={props.onTouchStart}
					style={{
						...props.style,
						height: '28px',
						display: 'flex',
						width: '100%',
						paddingTop: '32px'
					}}
				>
					<div ref={props.ref} style={styleTrack}>
						{children}
					</div>
				</div>
			)}
			renderThumb={({ index, props, isDragged }) => {
				return (
					<div
						{...props}
						style={{
							...props.style,
							height: '21px',
							width: '21px',
							backgroundColor: '#EEE',
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
							outline: 'none'
						}}
					>
						<ThumbLabel
							rangeRef = {rangeRef.current}
							values = {values}
							index = {index}
							colorMain = {colorMain}
							step={step}
						/>
						<div
							style={{
								height: '12px',
								width: '3px',
								borderRadius: '2px',
								backgroundColor: isDragged ? colorMain : '#CCC'
							}}
						/>
					</div>
				)
			}}
			{...props}
		/>
	)
}
